(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/statistics/assets/javascripts/horse-profile-single.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/statistics/assets/javascripts/horse-profile-single.js');

'use strict';

const {
  Image
} = svs.content.image_v2;
const {
  ImageTypes,
  getImageOptions
} = svs.racing.common.imageOptions;
const HorseProfileSingle = _ref => {
  let {
    selectedParticipant
  } = _ref;
  const silksFormattedDate = svs.utils.ns.isNamespace('svs.racing_game.data.race.meeting.silksFormattedDate') ? svs.racing_game.data.race.meeting.silksFormattedDate : '';
  const imageOptions = (selectedParticipant === null || selectedParticipant === void 0 ? void 0 : selectedParticipant.silks) && silksFormattedDate && getImageOptions(selectedParticipant.silks, silksFormattedDate, ImageTypes.StatisticsSilkBig);
  if (!selectedParticipant) {
    return null;
  }
  return React.createElement("div", {
    className: "horse-current"
  }, React.createElement("div", {
    className: "horse-current-dress"
  }, React.createElement(Image, {
    image: imageOptions
  })), React.createElement("div", {
    className: "horse-current-description"
  }, React.createElement("div", {
    className: "horse-current-horse-name"
  }, selectedParticipant.participantNumber, ".\xA0", selectedParticipant.horseName), React.createElement("div", {
    className: "horse-current-driver-name"
  }, selectedParticipant.driverName)));
};
svs.racing_game.components.statistics.HorseProfileSingle = HorseProfileSingle;

 })(window);